// Packages
import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"

// Components
import ToolTip from "components/Stacker/components/ToolTip/ToolTip"

// Styles
import "./Swatch.scss"

function Swatch(props) {
  const handleClick = () => {
    const { handleSwatchChange, index, variantCode } = props
    handleSwatchChange(index, variantCode)
  }

  const {
    color,
    variantCode,
    colorImage,
    baseCode,
    tabIndex,
    isChecked,
    isSelected,
    className,
    style,
    "data-index": dataIndex,
    showTooltip = false,
  } = props

  const inputId = `${color
    .split(" ")
    .join("-")}-${variantCode}-${baseCode}-${dataIndex}`

  return (
    <label
      htmlFor={inputId}
      className={classNames(`Swatch`, className, {
        "swatch-tooltip": showTooltip,
      })}
      style={style}
      data-index={dataIndex}
      tabIndex={tabIndex}
    >
      <input
        id={inputId}
        onChange={handleClick}
        type="radio"
        name={baseCode}
        checked={isChecked}
        aria-label={color}
      />
      <div className="wrapper d-flex justify-content-center">
        <div
          className={classNames(
            "image-wrapper d-flex align-items-center justify-content-center",
            { "checked-swatch": isChecked },
            { "selected-swatch": isSelected }
          )}
        >
          <img src={colorImage} className="swatch-image" alt="Product" />
        </div>
      </div>
      {showTooltip && <ToolTip tooltipText={color} />}
    </label>
  )
}

Swatch.propTypes = {
  handleSwatchChange: PropTypes.func.isRequired,
  color: PropTypes.string.isRequired,
  colorImage: PropTypes.string.isRequired,
  variantCode: PropTypes.string.isRequired,
  baseCode: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  isChecked: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool,
  tabIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  style: PropTypes.object,
  "data-index": PropTypes.number,
  showTooltip: PropTypes.bool,
}

export default Swatch
